export default {
  ERRORMODAL_01: 'Download Exceeded Limit',
  ERRORMODAL_02: 'AI ChatGPT generation has reached its usage limit, please upgrade',
  ERRORMODAL_03: 'Upgrade',
  ERRORMODAL_04: 'Quantity Exceeds Limit',
  ERRORMODAL_05: 'The number of files being edited simultaneously in the workspace has reached the usage limit, please upgrade',
  ERRORMODAL_06: 'Upgrade',
  ERRORMODAL_07: 'Generate Limit',
};
